module.exports = __webpack_public_path__ + "static/media/service_system_4.19babc28.png";